import { LearningLanguage, LessonFormat } from "./agreement";

export interface LessonStudentView {
  id: number;
  studentId: number;

  lessonDate: string;
  conducted: boolean;
  paid: boolean;
  attended: boolean;
  canBeConducted: boolean;

  learningLanguage: LearningLanguage;
  lessonFormat: LessonFormat;
  agreementName: string;

  teacherId: number;
  teacherFullName: string;
}

export interface Lesson {
  id: number;
  agreementId: number;
  lessonDate: string;
  type: LessonType;
  conducted: boolean;
  teacherId: number;
  teacherRate: number;
}

export interface LessonBulkCreateRequest {
  agreementId: number;
  lessonDates: string[];
}

export interface LessonStudentCreateRequest {
  studentId: number;
  lessonPrice?: number;
}

export interface LessonCreateRequest {
  agreementId: number;
  lessonDate: string;
  teacherRate?: number;
  type?: LessonType
  students: LessonStudentCreateRequest[];
}

export interface LessonStructureResponse {
  id: number;
  agreementId: number;
  teacher: LessonTeacherStructureResponse;
  lessonDate: string;
  type: LessonType;
  conducted: boolean;
  students: LessonStudentStructureResponse[];
}

export interface LessonTeacherStructureResponse {
  id: number;
  teacherRate: number;
  firstName: string;
  lastName: string;
}

export interface LessonStudentStructureResponse {
  id: number;
  lessonPrice: number;
  firstName: string;
  lastName: string;
  attended: boolean;
  paid: boolean;
}

export interface LessonStudentUpdateRequest {
  studentId: number;
  lessonPrice?: number;
  attended: boolean;
  paid: boolean;
}

export interface LessonUpdateRequest {
  lessonDate?: string;
  conducted: boolean;
  teacherRate?: number;
  type?: LessonType;
  students: LessonStudentUpdateRequest[];
}

export enum LessonType {
  USUAL = 'USUAL',
  TRIAL = 'TRIAL',
}

export const LessonTypeNameMap = {
  [LessonType.USUAL]: 'Обычный',
  [LessonType.TRIAL]: 'Пробный',
}